import React, { useContext, useEffect, useRef, useState } from "react";
import { ActionItem, ActionOnItem, ArtifactType, ContentState, ContentSubstate, getArtefactIcon } from "../../../../models/SKArtifact";
import TextArtifactContainer from "./TextArtifactContainer";
import DocumentArtifactContainer from "./DocumentAtrifactContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CreateArtifactContext } from "../../../../context/CreateArtifactContext";
import PhotoArtifactContainer from "./PhotoArtifactContainer";
import VideoArtifactContainer from "./VideoArtifactContainer";
import AudioArtifactContainer from "./AudioArtifactContainer";
import LinkArtifactContainer from "./LinkArtifactContainer";
import EventArtifactContainer from "./EventArtifactContainer";
import LoadingPopup from "../../../channels/create/LoadingPopup";
import PlaceArtifactContainer from "./PlaceArtifactContainer";
import LetterArtifactContainer from "./LetterArtifactContainer";
import JournalArtifactContainer from "./JournalArtifactContainer";
import GreetingsArtifactContainer from "./GreetingsArtifactContainer";
import StoryArtifactContainer from "./StoryArtifactContainer";
import PollsArtifactContainer from "./PollsArtifactContainer";
import GuideArtifactContainer from "./GuideArtifactContainer";
import ListArtifactContainer from "./ListArtifactContainer";
import { useNavigationBar } from "../../../../context/NavigationContext";
import { capitalizeFirstLetter, pluralize } from "../../../../utils/stringFunctions";
import { AnyObject, ObjectSchema } from "yup";
import ArtifactStateDialog, { DialoageContent } from "./components/ArtifactStateDialog";
import { deleteArtifact, deleteArtifactEdit, updateArtifactStatus } from "../../../../api/artifacts/atrifactService";
import { useUpdateList } from "../../../contentModeration/UpdateListContext";
import PopupSingleButton, { PopupActionStatus, PopupContent } from "../../../../components/PopupSingleButton";
import Yup from "yup";

export interface ArtifactContainerRef {
  containerSchema: () => ObjectSchema<{}, AnyObject, {}, "">;
  setErrors?: (errors: { [key: string]: string | undefined }) => void;
}

export default function CreateArtifact() {
  const {
    contentData,
    updateContentData,
    setArtifactId,
    artifactId,
    submit,
    updateStatus,
    loading,
    doneSubmitting,
    getContentActionableCreatorItems,
    containerButtonTitle,
    saveData,
    originalState,
    isEditable,
    clearUnsavedChanges,
  } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const [isValidForm, setIsValidForm] = useState(false);
  const { updateList } = useUpdateList();
  //const [isSubmitted, setIsSubmitted] = useState(false);
  // const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);

  const [actionDone, setActionDone] = useState<PopupContent | undefined>();

  const childRef = useRef<ArtifactContainerRef>(null);

  function getDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete this Content?",
          description: "Content will be permanently deleted form the system and you will not be able to recover it.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Withdraw Content?",
          description: "Users will not be able to view this Content anymore.",
          actionTitle: ActionItem.withdraw,
          destructiv: true,
        };
      default:
        return null;
    }
  }

  function getActionDone(action: ActionItem): PopupContent | undefined {
    switch (action) {
      case ActionItem.delete:
        return {
          title: "Successfully Deleted",
          message: "Your content is successfully deleted.",
          buttonTitle: "OK",
          status: PopupActionStatus.success,
        };
      case ActionItem.withdraw:
        return {
          title: "Successfully Withdrawn ",
          message: "Your content is successfully Withdrawn.",
          buttonTitle: "OK",
          status: PopupActionStatus.success,
        };
      case ActionItem.submit_for_review:
        return {
          title: "Successfully Submitted ",
          message: "Your content is successfully submitted for review.",
          buttonTitle: "OK",
          status: PopupActionStatus.success,
        };
      default:
        return undefined;
    }
  }

  // const updateStatus = async (actionItem: ActionItem, reason?: string, note?: string) => {
  //   if (!artifactId) return;
  //   switch (actionItem) {
  //     case ActionItem.delete:
  //       deleteArtifact(artifactId);
  //       break;
  //     case ActionItem.withdraw:
  //       //await updateArtifact(contentId, { status: State.rejected });
  //       await updateArtifactStatus(artifactId, ContentState.DRAFT, ContentSubstate.WITHDRAWN, reason, note);
  //       updateList(artifactId, ContentState.DRAFT, ContentSubstate.WITHDRAWN);
  //       updateContentData({ status: ContentState.DRAFT, subStatus: ContentSubstate.WITHDRAWN });
  //       await deleteArtifactEdit(artifactId);
  //       break;

  //     // case ActionItem.edit_submit:
  //     //   // await updateArtifact(contentId, { status: State.blocked });
  //     //   await updateArtifactStatus(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_IN_REVIEW, reason, note);
  //     //   updateContentData({ status: ContentState.ACTIVE, subStatus: ContentSubstate.EDIT_IN_REVIEW });
  //     //   updateList(artifactId, ContentState.ACTIVE, ContentSubstate.EDIT_IN_REVIEW);
  //     //   break;
  //     // case ActionItem.submit_for_review:
  //     //   // await updateArtifact(contentId, { status: State.blocked });
  //     //   await updateArtifactStatus(artifactId, ContentState.IN_REVIEW, ContentSubstate.NONE, reason, note);
  //     //   updateContentData({ status: ContentState.IN_REVIEW, subStatus: ContentSubstate.NONE });
  //     //   updateList(artifactId, ContentState.IN_REVIEW, ContentSubstate.NONE);
  //     //   break;
  //   }
  // };

  useEffect(() => {
    id && setArtifactId(id);
  }, [id]);

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  useEffect(() => {
    const validate = async () => {
      try {
        await childRef.current?.containerSchema().validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        let error = err as Yup.ValidationError;

        setIsValidForm(false);

        if (error.inner) {
          const errors = error.inner.reduce((acc: { [key: string]: string | undefined }, error1) => {
            if (error1.path) acc[error1.path] = error1.message; // Use `path` instead of `name` (Yup uses `path`)
            return acc;
          }, {});
          if (childRef.current?.setErrors) {
            childRef.current?.setErrors(errors);
          }
          console.log("Validation errors:", errors);
        }
      }
    };
    validate();
  }, [contentData, childRef.current?.containerSchema]);

  useEffect(() => {
    setNavProps({
      backArrow: false,
      title: "Create",
      subtitle: contentData.status === ContentState.ACTIVE ? "" : capitalizeFirstLetter(contentData.type ?? ""),
      userActions:
        contentData.status === ContentState.ACTIVE
          ? `${pluralize(contentData.viewCount ?? 0, "View")} . ${pluralize(contentData.likeCount ?? 0, "Like")} . ${pluralize(
              contentData.loveCount ?? 0,
              "Heart"
            )} . ${pluralize(contentData.shareCount ?? 0, "Share")} . ${pluralize(contentData.bookmarkCount ?? 0, "Bookmark")}`
          : "",
      icon: contentData.type ? getArtefactIcon(contentData.type) : undefined,
      buttonTitle: "Submit",
      filterOption: false,
      enableLink: isEditable ? isValidForm : false,
      getActionItems: getContentActionableCreatorItems,
      onActionItemSelect: actionItem => {
        setActionOnItem({
          itemid: artifactId!,
          action: actionItem as ActionItem,
        });
      },
      onNext:
        contentData.status === ContentState.DRAFT
          ? async () => {
              await submit();
              //setIsSubmitted(true);
              setActionDone(getActionDone(ActionItem.submit_for_review));
              // updateList(artifactId!, ContentState.IN_REVIEW, ContentSubstate.NONE);
              // updateContentData({ status: ContentState.IN_REVIEW, subStatus: ContentSubstate.NONE });
            }
          : undefined,
      onEdit: contentData.status === ContentState.ACTIVE ? requestEdit : undefined,

      onClose: async () => {
        if (contentData.status === ContentState.DRAFT) {
          await saveData();
        }
        setTimeout(() => {
          navigate(-1); // state reflects the updated value here
        }, 0);
      },
    });
  }, [contentData, getContentActionableCreatorItems, isValidForm, artifactId]);

  const requestEdit = async () => {
    navigate("edit");
  };

  useEffect(() => {
    if (doneSubmitting) {
      navigate("successSubmit");
    }
  }, [doneSubmitting]);

  const element = () => {
    // if (contentData.type && artifactId)
    switch (contentData.type) {
      case ArtifactType.text:
        return <TextArtifactContainer ref={childRef} />;

      case ArtifactType.audio:
        return <AudioArtifactContainer ref={childRef} />;

      case ArtifactType.document:
        return <DocumentArtifactContainer ref={childRef} />;

      case ArtifactType.event:
        return <EventArtifactContainer ref={childRef} />;

      case ArtifactType.greeting:
        return <GreetingsArtifactContainer ref={childRef} />;

      case ArtifactType.journal:
        return <JournalArtifactContainer ref={childRef} />;

      case ArtifactType.letter:
        return <LetterArtifactContainer ref={childRef} />;

      case ArtifactType.link:
        return <LinkArtifactContainer ref={childRef} />;

      case ArtifactType.list:
        return <ListArtifactContainer ref={childRef} />;

      case ArtifactType.photo:
        return <PhotoArtifactContainer ref={childRef} />;

      case ArtifactType.place:
        return <PlaceArtifactContainer ref={childRef} />;

      case ArtifactType.guide:
        return <GuideArtifactContainer ref={childRef} />;

      case ArtifactType.poll:
        return <PollsArtifactContainer ref={childRef} />;

      case ArtifactType.story:
        return <StoryArtifactContainer ref={childRef} />;

      case ArtifactType.video:
        return <VideoArtifactContainer ref={childRef} />;

      default:
        break;
    }
    return <></>;
  };

  return (
    <>
      <LoadingPopup isLoading={loading} loadingText="Loading" />
      {actionOnItem?.action && dialogContent ? (
        <ArtifactStateDialog
          action={actionOnItem?.action}
          onClose={() => setActionOnItem(null)}
          onUpdate={async () => {
            const action = actionOnItem?.action;
            await updateStatus(action);
            updateList(artifactId!, undefined, contentData.subStatus);
            if (action === ActionItem.delete) {
              clearUnsavedChanges && clearUnsavedChanges();
              navigate(-1);
              return;
            }
            setActionOnItem(null);
            setTimeout(() => {
              setActionDone(getActionDone(action));
            }, 0);
          }}
          dialogeContent={dialogContent}
        />
      ) : (
        <></>
      )}
      {actionDone && (
        <PopupSingleButton
          popupContent={actionDone}
          onClose={async () => {
            setActionDone(undefined);
            navigate(-1);
          }}
        />
      )}
      {element()}
    </>
  );
}
